import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  sku: {
    id: 'K1itmF',
    defaultMessage: 'SKU',
    description: 'Table column header for SKU',
  },
  warehouseLocation: {
    id: 'KGvjSk',
    defaultMessage: 'Warehouse location',
    description: 'Table column header for Warehouse location',
  },
  select: {
    id: '5/ygLb',
    defaultMessage: 'Select...',
    description: 'Select label for dropdown placeholder',
  },
  lot: {
    id: 'ZQ7biT',
    defaultMessage: 'Lot ID',
    description: 'Table column header for Lot ID',
  },
  lotPlaceholder: {
    id: 'dUt8n9',
    defaultMessage: 'Lot #',
    description: 'Table column header for Lot ID',
  },
  expiryDate: {
    id: 'T1GQgP',
    defaultMessage: 'Exp. Date',
    description: 'Table column header for Exp. Date',
  },
  accept: {
    id: 'yalT7r',
    defaultMessage: 'Accept',
    description: 'Table column header for Acceptance',
  },
  reject: {
    id: 'ds43Uq',
    defaultMessage: 'Reject',
    description: 'Table column header for Rejection',
  },
  received: {
    id: 'jnkEga',
    defaultMessage: 'Received',
    description: 'Table column header for Receiving',
  },
});
